import {
  Action,
  ActionType,
  ISubscribeSuperCityResponse,
} from "models/patients/subscribeSuperCity";
import createReducer from "redux/createReducer";

export interface SubscribeSuperCityReducerType {
  loading: boolean;
  error?: string;
  subscribeSuperCityResponse?: ISubscribeSuperCityResponse;
}

const defaultState: SubscribeSuperCityReducerType = {
  loading: false,
  error: undefined,
  subscribeSuperCityResponse: undefined,
};

export const subscribeSuperCityReducer =
  createReducer<SubscribeSuperCityReducerType>(defaultState, {
    [ActionType.SUBSCRIBE_SUPER_CITY](state: SubscribeSuperCityReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SUBSCRIBE_SUPER_CITY_ERROR](
      state: SubscribeSuperCityReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.SUBSCRIBE_SUPER_CITY_SUCCESS](
      state: SubscribeSuperCityReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        subscribeSuperCityResponse: action.payload,
      };
    },

    [ActionType.SUBSCRIBE_SUPER_CITY_RESET](
      state: SubscribeSuperCityReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        subscribeSuperCityResponse: undefined,
      };
    },
  });
